import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function HeroSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  const bullets = ['Si compras leads de Zillow o Realtor.com que ya recibieron llamadas de 10 agentes antes que tú', 'Si tu base de datos de contactos está dormida y no sabes cómo reactivarla', 'Si tus anuncios de Facebook atraen curiosos que no tienen pre-aprobación bancaria', 'Si dependes de tu esfera personal para conseguir transacciones y ya la agotaste', 'Si ves a otros agentes cerrando 5 transacciones al mes mientras tú luchas por 1 o 2'];
  return <section className="relative min-h-[90vh] flex items-center justify-center pt-24 pb-16 px-5 md:px-8 overflow-hidden" data-id="element-19">
      {/* Subtle background glow */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[300px] md:w-[600px] h-[300px] md:h-[600px] bg-gold/5 rounded-full blur-[100px] md:blur-[120px] pointer-events-none" data-id="element-20" />

      <div className="max-w-4xl mx-auto w-full relative z-10" data-id="element-21">
        <motion.div variants={containerVariants} initial="hidden" animate="visible" className="flex flex-col items-center text-center" data-id="element-22">
          <motion.h1 variants={itemVariants} className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-gold leading-[1.1] tracking-tight mb-6" data-id="element-23">
            ¿Persiguiendo leads fríos que no tienen pre-aprobación ni intención
            real de comprar?
          </motion.h1>

          <motion.p variants={itemVariants} className="text-base sm:text-lg md:text-xl text-gray-300 mb-10 md:mb-12 max-w-3xl leading-relaxed" data-id="element-24">
            Implementamos el{' '}
            <span className="text-white font-semibold" data-id="element-25">Sistema A.C.E.™</span>{' '}
            para Agentes de Real Estate: el protocolo que atrae compradores y
            vendedores calificados que están listos para actuar en los próximos
            30 a 90 días.
          </motion.p>

          <motion.div variants={itemVariants} className="w-full max-w-2xl text-left mb-10 md:mb-12 bg-dark-200/50 border border-dark-100 p-6 md:p-8 rounded-lg" data-id="element-26">
            <ul className="space-y-5" data-id="element-27">
              {bullets.map((bullet, index) => <motion.li key={index} variants={itemVariants} className="flex items-start gap-4" data-id="element-28">
                  <AlertTriangleIcon className="w-5 h-5 md:w-6 md:h-6 text-red-500 shrink-0 mt-0.5" data-id="element-29" />
                  <span className="text-gray-300 text-sm sm:text-base md:text-lg leading-snug" data-id="element-30">
                    {bullet}
                  </span>
                </motion.li>)}
            </ul>
          </motion.div>

          <motion.div variants={itemVariants} className="w-full sm:w-auto" data-id="element-31">
            <Button href="https://calendar.app.google/PYPdcRoYne7QrNJA7" data-id="element-32">
              QUIERO LEADS DE COMPRADORES CALIFICADOS
            </Button>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}